export default {
  notification: {
    success: {
      reply: 'Tweet responded successfully!',
      remove: 'Page removed successfully!',
    },
    error: {
      reply: 'Error responding to the tweet!',
      remove: 'Error removing the page!',
    },
  },
  label: {
    pageSession: 'Select a page to respond:',
    pageLabel: 'Pages',
    suggestionSession: 'Generate response suggestions via chatGPT:',
    replySession: 'Edit the selected suggestion or write a response:',
    replyLabel: 'Reply @{username}',
    rules: {
      minChar: 'Minimum of {minChar} characters required',
      maxChar: 'Maximum of {maxChar} characters allowed',
    },
    button: {
      generateSuggestions: 'Generate Suggestions',
      reply: 'Reply',
      remove: 'Remove',
    },
    status: {
      withoutData: 'No publication found',
      errorData: 'Error processing your request.',
    },
    closeLabel: 'Close',
  },
  faq: {
    question: 'Why can I only respond to Twitter (X) posts directly through the component?',
    response: 'Due to limitations of the APIs of other social networks, it is not allowed to create comments on posts from other networks. This functionality is only available for the X (Twitter) social network.',
  },
};
